export default "__VITE_ASSET__D6TSj7An__"